module.exports = __webpack_public_path__ + "res/28-img_info_t.b9e9ec830bfc82e7f792e14cfeea5243.png";